import React from 'react';
function OpenAccount() {
    return (
        <div className="container">
            <div className="row text-center">
                <h1 className="mb-4">Open a FinPlot account</h1>
                <p style={{color:"gray"}} className='mb-5'>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
                <button className='p-2 fs-4  btn btn-primary mb-5' style={{width:"15%" , margin: "0 auto", fontWeight:"500" }}>Sign up for free</button>
            </div>
        </div>
     );
}

export default OpenAccount;